/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Quota_LabelInputs */

const en_backend_quota_label = /** @type {(inputs: Backend_Quota_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage quota`)
};

const fr_backend_quota_label = /** @type {(inputs: Backend_Quota_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota d'utilisation`)
};

const ms_sg2_backend_quota_label = /** @type {(inputs: Backend_Quota_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota penggunaan`)
};

/**
* | output |
* | --- |
* | "Usage quota" |
*
* @param {Backend_Quota_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_quota_label = /** @type {((inputs?: Backend_Quota_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Quota_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_quota_label(inputs)
	if (locale === "fr") return fr_backend_quota_label(inputs)
	return ms_sg2_backend_quota_label(inputs)
});